import ProvisionalReceiptError from './ProvisionalReceiptError';

export default ProvisionalReceiptError;
